export const convertTemperatureToCelsius = (value: number) => {
    const celsius = ((value - 32) * 5 / 9).toFixed(2);
    return {
        value: `${celsius} C`,
        onlyNumber: celsius
    }
}

export const isRouteInList = (route: string, routeList: string[]) => {
    return routeList.some((r) => {
        if (r.endsWith("*")) {
            const baseRoute = r.slice(0, -1); // Remove the "*" at the end
            return route.startsWith(baseRoute);
        }
        return r === route;
    });
};